import React from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { useLocation } from 'react-router-dom';
import { required } from 'redux-form-validators';
import { DateField, DefaultButton, ReduxTextField } from 'common/components';
import { createApiToken, updateApiToken } from '../../_redux';

const validate = ({ title }) => {
  const errors = {};

  if (!/^[A-Za-z_]+$/.test(title)) {
    errors.title = <FormattedMessage id="apiTokenNameValidate" />;
  }

  return errors;
};

const TokensForm = ({ submitting, isUpdateForm, invalid, pristine, handleSubmit, dispatch, tokenId }) => {
  const location = useLocation();
  const search = { ...queryString.parse(location.search) };

  const submit = handleSubmit(({ expires, ...formValues }) => {
    if (isUpdateForm) {
      updateApiToken({ ...formValues, tokenId, search, expires: expires || null }, dispatch);
    } else {
      createApiToken({ ...formValues, expires: expires || null }, dispatch);
    }
  });

  return (
    <form className="TokensForm" onSubmit={submit}>
      <Field component={ReduxTextField} name="title" textId="tokenName" validate={[required()]} disabled={submitting} />
      <Field component={DateField} areFutureDaysAvailable name="expires" textId="expiringDate" disabled={submitting} />
      <DefaultButton
        textId={isUpdateForm ? 'doSave' : 'justCreate'}
        type="submit"
        loading={submitting}
        disabled={invalid || pristine || submitting}
        filled
      />
    </form>
  );
};

TokensForm.propTypes = {
  isUpdateForm: PropTypes.bool,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  tokenId: PropTypes.number,
};

TokensForm.defaultProps = {
  isUpdateForm: false,
  tokenId: null,
};

export default compose(
  reduxForm({
    form: 'TokensForm',
    validate,
  })
)(TokensForm);

export { TokensForm };
